import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { fetchInvoices } from '../../../actions/invoice/invoiceList'
import Invoices, { Row } from '../../Client/Invoices'
import { AppState } from '../../../reducers'
import { FiltersBar, Filters } from '../../Utils/Filters/Filter'
import { FilterFromDate, FilterToDate, FilterNumber, FilterStatusOrder, FilterStatusPrepayment, FilterText, FilterTel, FilterAssignedToComplaint, FilterStatusComplaint, FilterReceipts } from '../../Utils/Filters'
import { InvoiceListState } from '../../../reducers/invoice/invoiceList'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import Invoice from '../../../models/Invoice'
import { SessionState, isAdmin, isClient, isHeadSales, isManager, isStaff, isVendor } from '../../../reducers/auth/session'
import { OrderListState } from '../../../reducers/order/orderList'
import { ClientDetailState } from '../../../reducers/client/clientDetail'
import { fetchOrders } from '../../../actions/order/orderList'
import { fetchClient } from '../../../actions/client/clientDetail'
import { Orders } from '../../Client/Orders'
import Order from '../../../models/Order'
import { ClientInformation } from '../Clients/ClientsDetail'
import { PersonListState } from '../../../reducers/person/personList'
import { fetchPeople } from '../../../actions/person/personList'
import { roleToURLPrefix } from '../../../App'
import { PERSON } from '../../../models/User'
import { KeyboardReturnOutlined } from '@mui/icons-material'
import { Box, Button } from '@mui/material'
import Prepayments from '../../Client/Prepayments'
import { fetchPrepayments } from '../../../actions/prepayment/prepaymentList'
import { fetchPreorders } from '../../../actions/preorder/preorderList'
import { PreorderListState } from '../../../reducers/preorder/preorderList'
import { PrepaymentListState } from '../../../reducers/prepayment/prepaymentList'
import { fetchComplaintTypes } from '../../../actions/complaint/complaintTypesList'
import { fetchGeneralDesc } from '../../../actions/generalDesc'
import { fetchComplaints } from '../../../actions/complaint/complaintList'
import { ComplaintListState } from '../../../reducers/complaint/complaintList'
import Complaints from '../../Client/Complaints'
import Complaint from '../../../models/Complaint'
import { fetchPrepaymentCount } from '../../../actions/prepayment/prepaymentCount'
import { downloadAzureFile } from '../../Utils/downloadAzureFile'
import { fetchInvoiceAzure } from '../../../actions/invoice/invoiceAzure'
import InvoiceAzure from '../../../models/InvoiceAzure'
import TableDiscountList from '../../DiscountList/TableDiscountList'
import { fetchDiscountList } from '../../../actions/discountList'
import { DiscountListState } from '../../../reducers/discountList'
import Preorders from '../../Client/Preorders'
import Preorder from '../../../models/Preorder'
import { PreorderCtrlListState } from '../../../reducers/preorder/preorderCtrlList'
import { fetchCtrlPreorders } from '../../../actions/preorder/preorderCtrlList'
import { DeliveryLocationListState } from '../../../reducers/deliveryLocation/deliveryLocationList'
import { ProvinceListState } from '../../../reducers/province/provinceList'
import { fetchProvinces } from '../../../actions/deliveryLocation/provinceList'
import { fetchDeliveryLocations } from '../../../actions/deliveryLocation/deliveryLocationList'
import CurrentAccounts from '../../Client/CurrentAccounts'
import { CurrentAccountListState } from '../../../reducers/currentAccount/currentAccountList'
import { fetchCurrentAccounts } from '../../../actions/currentAccount/currentAccountList'
import CurrentAccount from '../../../models/CurrentAccount'
import { receiptLegalTypes } from '../../GeneralDesc'
import { UnifiedInvoiceRow } from '../../Client/Invoices/InvoicesList'
import BouncedReceipt from '../../../models/BouncedReceipt'
import { fetchBouncedReceipts } from '../../../actions/bouncedReceipt/bouncedReceiptList'
import { BouncedReceiptListState } from '../../../reducers/bouncedReceipt/bouncedReceiptList'
import Pagination from '../../../models/Pagination'
import { getToken } from '../../../utils/fetchApi'
import { GeneralDescState } from '../../../reducers/generalDescList'

interface Props {
  fullInfo?: boolean
  invoiceList: InvoiceListState
  bouncedReceiptList: BouncedReceiptListState
  currentAccountList: CurrentAccountListState
  orderList: OrderListState
  prepaymentList: PrepaymentListState
  preorderList: PreorderListState
  preorderCtrlList: PreorderCtrlListState
  complaintList: ComplaintListState
  clientDetail: ClientDetailState
  personList: PersonListState
  discountList: DiscountListState
  deliveryLocationList: DeliveryLocationListState
  provinceList: ProvinceListState
  generalDescList: GeneralDescState
  session: SessionState
}

const InfoClientList: React.FC<Props> = ({ invoiceList, bouncedReceiptList, orderList, currentAccountList, prepaymentList, preorderList, preorderCtrlList, complaintList, clientDetail, fullInfo = true, discountList, session, personList, deliveryLocationList, provinceList, generalDescList }) => {
  const [fileAzure, setFileAzure] = useState<string>('')
  const [orderPage, setOrderPage] = useState<number>(0)
  const [preorderPage, setPreorderPage] = useState<number>(0)
  const [invoicePage, setInvoicePage] = useState<number>(0)
  const [prepaymentPage, setPrepaymentPage] = useState<number>(0)
  const [complaintPage, setComplaintPage] = useState<number>(0)
  const [prepaymentCount, setPrepaymentCount] = useState<number>(0)
  const [unifiedRows, setUnifiedRows] = useState<UnifiedInvoiceRow[]>([])
  const [mergedPagination, setMergedPagination] = useState<Pagination | undefined>(undefined)
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation(['invoice', 'order', 'prepayment', 'complaint'])
  const params = useParams<{ codigo_cliente: string }>()

  const isLogistic = generalDescList?.generalDesc?.some(gd => gd.id === session?.categoryId && gd.code === 'log');
  const isAccounts = generalDescList?.generalDesc?.some(gd => gd.id === session?.categoryId && gd.code === 'cc');

  const initInfoClientDefaultFilters: Filters = {
    invoiceFrom: moment().startOf('year').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    invoiceTo: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
    currentAccountFrom: moment().startOf('year').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    currentAccountTo: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
    from: moment().startOf('month').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    to: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
    dueFrom: moment().year(2000).startOf('year').tz("America/Argentina/Buenos_Aires").format(),
    dueTo: moment().year(2099).endOf('year').tz("America/Argentina/Buenos_Aires").format(),
    codigo_cliente: isAdmin(session) || isStaff(session) || isHeadSales(session) || isManager(session) || isVendor(session) ? params.codigo_cliente : '',
    statusPP: 'ACTIVO',
    dateOpenFrom: moment().startOf('year').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    dateOpenTo: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
    dateCloseFrom: '',
    dateCloseTo: moment().year(2099).endOf('year').tz("America/Argentina/Buenos_Aires").format(),
    statusCP: 'U,R',
    assignedToId: !isClient(session) ? 'N,M,O' : '',
    ownerOpenId: isClient(session) ? 'M,O' : ''
  }

  const initInfoClientPrepaymentDefaultFilters: Filters = {
    invoiceFrom: moment().startOf('year').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    invoiceTo: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
    currentAccountFrom: moment().startOf('year').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    currentAccountTo: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
    from: moment().startOf('month').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    to: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
    dueFrom: moment().year(2000).startOf('year').tz("America/Argentina/Buenos_Aires").format(),
    dueTo: moment().year(2099).endOf('year').tz("America/Argentina/Buenos_Aires").format(),
    codigo_cliente: isAdmin(session) || isStaff(session) || isHeadSales(session) || isManager(session) || isVendor(session) ? params.codigo_cliente : '',
    statusPP: 'ACTIVO',
    dateOpenFrom: moment().startOf('year').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    dateOpenTo: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
    dateCloseFrom: '',
    dateCloseTo: moment().year(2099).endOf('year').tz("America/Argentina/Buenos_Aires").format(),
    statusCP: 'U,R',
    assignedToId: !isClient(session) ? 'N,M,O' : '',
    ownerOpenId: isClient(session) ? 'M,O' : ''
  }

  useEffect(() => {
    dispatch(fetchComplaintTypes())
    dispatch(fetchGeneralDesc('?type=cpt'))
  }, [dispatch])

  useEffect(() => {
    dispatch(fetchPrepaymentCount(params.codigo_cliente, (count: number) => setPrepaymentCount(count)))
  }, [dispatch, params.codigo_cliente])


  useEffect(() => {
    const searchWithoutPage = history.location.search.indexOf('&page=') > 0 ?
      history.location.search ? history.location.search.slice(0, history.location.search.indexOf('&page=')) : '' :
      history.location.search ? history.location.search : ''
    const fetchSearch = searchWithoutPage ? `${searchWithoutPage}&limit=25` : `?limit=25`
    dispatch(fetchInvoices(`${fetchSearch}${invoicePage ? `&page=${invoicePage}` : ''}`))
    dispatch(fetchBouncedReceipts(`${fetchSearch}${invoicePage ? `&page=${invoicePage}` : ''}`))
    dispatch(fetchOrders(`${fetchSearch}${orderPage ? `&page=${orderPage}` : ''}`))
    dispatch(fetchCurrentAccounts(`?codigo_cliente=${params.codigo_cliente}&limit=1000`))

    dispatch(fetchPreorders(`?statusPO=A,P,N,H,D,R&codigo_cliente=${params.codigo_cliente}&limit=5${preorderPage ? `&page=${preorderPage}` : ''}`))
    dispatch(fetchCtrlPreorders(`?codigo_cliente=${params.codigo_cliente}&limit=1000`))

    dispatch(fetchPrepayments(`${fetchSearch}${prepaymentPage ? `&page=${prepaymentPage}` : ''}`))

    dispatch(fetchComplaints(`${fetchSearch}${complaintPage ? `&page=${complaintPage}` : ''}`))
    dispatch(fetchDiscountList(`?codigo_cliente=${params.codigo_cliente}`))
    dispatch(fetchClient(params.codigo_cliente))
    dispatch(fetchPeople(`?personType=C&byPersonTypeId=${params.codigo_cliente}`))
    dispatch(fetchProvinces(`?all=true`))
    dispatch(fetchDeliveryLocations(`?codigo_cliente=${params.codigo_cliente}`))
  }, [dispatch, history.location.search, params.codigo_cliente, invoicePage, orderPage, preorderPage, prepaymentPage, complaintPage])


  const linkToInvoiceDetail = (data: UnifiedInvoiceRow) => {
    const dataUrl = `${data.tipo === 'CR' ? `/bouncedReceipts/detailId/${(data.data as BouncedReceipt).registro}&${params.codigo_cliente}` : `/accounts/detail/${(data.data as Invoice).id_factura}`}`
    const paramsUrl = isVendor(session) ? `${dataUrl}&${params.codigo_cliente}` : `${dataUrl}`
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}${paramsUrl}`
    history.push(detailUrl)
  }


  const linkToOrderDetail = (order: Order) => {
    const paramsUrl = isVendor(session) ? `${order.id_pedido}&${params.codigo_cliente}` : `${order.id_pedido}`
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/orders/detail/${paramsUrl}`
    history.push(detailUrl)
  }

  const linkToCurrentAccountDetail = (currentAccount: CurrentAccount) => {
    if (currentAccount.comprobante.includes('CR')) {
      const match = currentAccount.comprobante.match(/^([A-Z]+)\s+(\d+)-(\d+)$/);
      if (match) {
        //const tipo = match[1]; // 'CR'
        const sucursal = match[2];  // '0001'
        const numero = match[3];    // '00002345'

        const paramsUrl = !isClient(session) ? `${sucursal}&${numero}&${params.codigo_cliente}` : `${sucursal}&${numero}`
        const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/bouncedReceipts/detail/${paramsUrl}`;
        history.push(detailUrl)
      }
    }
    else {
      if (receiptLegalTypes.includes(currentAccount.comprobante.charAt(0))) {
        const paramsUrl = isVendor(session) ? `${currentAccount.comprobante}&${params.codigo_cliente}` : `${currentAccount.comprobante}`
        const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/accounts/detail/${paramsUrl}`
        history.push(detailUrl)
      }
    }
  }

  const linkToPreorderDetail = (preorder: Preorder) => {
    const paramsUrl = isVendor(session) ? `${preorder.id}&${params.codigo_cliente}` : `${preorder.id}`
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/preorders/detail/${paramsUrl}`
    history.push(detailUrl)
  }

  const linkToPrepaymentDetail = (prepaymentId: string) => {
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/prepayments/detail/${prepaymentId}`
    history.push(detailUrl)
  }

  const linkToComplaintTracking = (complaint: Complaint) => {
    const addUrl = isAdmin(session) ? `/admin/complaints/viewMessages?complaintId=${complaint.id}&viewClientInfo=true` : `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/complaints/viewMessages/${complaint.id}&true`
    history.push(addUrl, { title: t('complaintTracking', { ns: 'complaint' }) })
  }

  const linkToBack = () => {
    const url = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/clients`
    history.push(url)
  }

  const constructPrepaymentRows = () => {
    const rows = (prepaymentList.prepayments || []).filter((pp) => pp.fecha >= '2024-06-18' &&
      preorderCtrlList.preorders?.every((po) => (po.status !== 'A' && po.status !== 'P' && po.status !== 'H' && po.status !== 'C') || po.prepaymentId !== pp.id_acopio)).map(s => ({ data: s }))
    const inUseA = (prepaymentList.prepayments || []).filter((pp) =>
      preorderCtrlList.preorders?.some((po) => (po.status === 'A') && po.prepaymentId === pp.id_acopio)).map(s => ({ action: "disabled", statusPO: 'A', user: '', data: s }));
    const inUseP = (prepaymentList.prepayments || []).filter((pp) =>
      preorderCtrlList.preorders?.some((po) => (po.status === 'P') && po.prepaymentId === pp.id_acopio)).map(s => ({ action: "disabled", statusPO: 'P', user: '', data: s }));
    const inUseH = (prepaymentList.prepayments || []).filter((pp) =>
      preorderCtrlList.preorders?.some((po) => (po.status === 'H') && po.prepaymentId === pp.id_acopio)).map(s => ({ action: "disabled", statusPO: 'H', user: '', data: s }));
    const inUseC = (prepaymentList.prepayments || []).filter((pp) =>
      preorderCtrlList.preorders?.some((po) => (po.status === 'C') && po.prepaymentId === pp.id_acopio)).map(s => ({ action: "disabled", statusPO: 'C', user: '', data: s }));
    const inUseN = (prepaymentList.prepayments || []).filter((pp) => pp.fecha < '2024-06-18').map(s => ({ action: "disabled", statusPO: 'N', user: '', data: s }));

    inUseA.every(s => s.user = preorderCtrlList.preorders?.find(p => s.data.id_acopio === p.prepaymentId)?.owner?.fullName ?? '');
    inUseP.every(s => s.user = preorderCtrlList.preorders?.find(p => s.data.id_acopio === p.prepaymentId)?.owner?.fullName ?? '');
    inUseH.every(s => s.user = preorderCtrlList.preorders?.find(p => s.data.id_acopio === p.prepaymentId)?.owner?.fullName ?? '');
    inUseC.every(s => s.user = preorderCtrlList.preorders?.find(p => s.data.id_acopio === p.prepaymentId)?.owner?.fullName ?? '');
    inUseN.every(s => s.user = preorderCtrlList.preorders?.find(p => s.data.id_acopio === p.prepaymentId)?.owner?.fullName ?? '');

    return rows.concat(inUseA).concat(inUseP).concat(inUseH).concat(inUseC).concat(inUseN).sort((a, b) => a.data.fecha > b.data.fecha ? -1 : a.data.fecha < b.data.fecha ? 1 : 0);
  }


  useEffect(() => {
    if (fileAzure) {
      (async () => {
        try {
          const res = await fetch(`${process.env.REACT_APP_API_URL}/invoiceDownloadCheck?url=${encodeURIComponent(fileAzure)}`, {
            headers: { Authorization: `Bearer ${getToken()}` }
          });
          const data = await res.json();

          if (data.exists) {
            // El archivo existe: abrir en nueva pestaña o ventana
            window.location.assign(fileAzure)
          } else {
            // No existe o no accesible (404, 403, etc.)
            console.error('Archivo inexistente o inaccesible:', res.status);
            window.alert('No se pudo descargar el comprobante. El comprobante no está disponible en este momento. Intente más tarde.');
          }
        } catch (err) {
          console.error('Error verificando el comprobante:', err);
          window.alert('Error al intentar verificar y descargar el comprobante. El archivo no está disponible en este momento. Intente más tarde.');
        }
      })();
    }
  }, [fileAzure])

  const handleAzureFile = (doc: InvoiceAzure) => {
    setFileAzure(downloadAzureFile(doc.pathpdfazure, doc.nombrepdf, doc.tipo === 'FE' || doc.tipo === 'CE' || doc.tipo === 'DE' ? 'ME' : ''));
  }

  const handleBouncedReceiptAzureFile = (doc: BouncedReceipt) => {
    setFileAzure(downloadAzureFile(doc.pathpdfazure, doc.nombre_pdf, 'CR'));
  }

  const handleErrorAzureFile = (err: Error) => {
    window.alert(err.message);
  }

  const downloadInvoice = (row: Row) => {
    const clientParam = isAdmin(session) || isStaff(session) || isManager(session) || isHeadSales(session) || isVendor(session) ? `&codigocliente=${row.data.codigo_cliente}` : ''
    const params = `?tipo=${row.data.tipo}&sucursal=${row.data.sucursal}&numero=${row.data.numero}${clientParam}`
    if (row.data.source === 'invoice')
      dispatch(fetchInvoiceAzure(params, handleAzureFile, handleErrorAzureFile))
    else
      handleBouncedReceiptAzureFile(row.data.data as BouncedReceipt)
  }


  useEffect(() => {
    if (invoiceList && !invoiceList.isFetching && bouncedReceiptList && !bouncedReceiptList.isFetching) {
      const invoiceRows: UnifiedInvoiceRow[] = invoiceList && invoiceList.invoices ? invoiceList.invoices.map(inv => ({
        source: 'invoice',
        id: inv.id_factura,
        fecha: inv.fecha,
        codigo_cliente: inv.codigo_cliente,
        numero: inv.factura_numero,
        sucursal: inv.factura_prefijo,
        fecha_vencimiento: inv.fecha_vencimiento,
        importe_total: inv.importe_total_comprobante,
        tipo: inv.factura_comprobante,
        status: inv.status,
        data: inv as Invoice
      })) : [];


      const bouncedRows: UnifiedInvoiceRow[] = bouncedReceiptList &&
        bouncedReceiptList.bouncedReceipts ? bouncedReceiptList.bouncedReceipts.map(rec => ({
          source: 'bounced',
          id: String(rec.registro),
          fecha: rec.fecha,
          codigo_cliente: rec.codigo_cliente,
          numero: rec.numero,
          sucursal: rec.sucursal,
          fecha_vencimiento: rec.vencimiento,
          importe_total: rec.importe_total,
          tipo: rec.tipo,
          status: rec.status,
          data: rec as BouncedReceipt
        })) : [];

      const combined = [...invoiceRows, ...bouncedRows]
        .sort((a, b) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime());

      setUnifiedRows(combined);

      const totalCount = (invoiceList.pagination?.count || 0) + (bouncedReceiptList.pagination?.count || 0)
      const currentPage = invoiceList.pagination?.page || 0

      setMergedPagination({
        size: invoiceList.pagination?.count ? invoiceList.pagination.size : bouncedReceiptList.pagination.size,
        count: totalCount,
        page: currentPage
      })
    }
  }, [invoiceList, bouncedReceiptList]);

  return (
    <div>
      <ClientInformation client={clientDetail} personList={personList} deliveryLocationList={deliveryLocationList} provinceList={provinceList} />
      {fullInfo && (!isStaff(session) || (isStaff(session) && !isLogistic)) &&
        <FiltersBar defaultFilters={initInfoClientDefaultFilters}>
          <FilterFromDate name="invoiceFrom" label={t("fromDate")} />
          <FilterToDate name="invoiceTo" label={t("toDate")} />
          <FilterNumber name="invoiceNumber" label={t("number")} />
          <FilterFromDate name="dueFrom" label={t("fromDueDate")} />
          <FilterToDate name="dueTo" label={t("toDueDate")} />
          <FilterReceipts name="receipts" label={t("receipt")} />
        </FiltersBar>}
      {(!isStaff(session) || (isStaff(session) && !isLogistic)) &&
        <Invoices
          rows={(unifiedRows || []).map(s => ({ data: s }))}
          loading={invoiceList.isFetching || bouncedReceiptList.isFetching}
          fullInfo={fullInfo}
          adminInfo={true}
          pagination={mergedPagination || undefined}
          showDownloadButton={true}
          onClickInfo={linkToInvoiceDetail}
          onChangePage={setInvoicePage}
          onClickDownload={downloadInvoice}
        />}
      {(!isStaff(session) || (isStaff(session) && !isLogistic)) &&
      
        <CurrentAccounts
          rows={(currentAccountList.currentAccounts || []).map(s => ({ data: s }))}
          electronicStockRows={(currentAccountList.electronicStock || []).map(s => ({ data: s }))}
          loading={currentAccountList.isFetching}
          fullInfo={fullInfo}
          adminInfo={isAdmin(session) || isHeadSales(session) || isManager(session) || isStaff(session) || isVendor(session)}
          pagination={undefined} //{currentAccountList.pagination || undefined}
          codigo_cliente={params.codigo_cliente}
          showDownloadButton={true}
          onClickInfo={linkToCurrentAccountDetail}
        />}
      {(!isStaff(session) || (isStaff(session) && !isLogistic && !isAccounts)) &&
        <Preorders
          rows={(preorderList.preorders || []).filter(s => s.status !== 'C').map(s => ({ data: s }))}
          loading={preorderList.isFetching!}
          initShowInfo={false}
          fullInfo={fullInfo}
          pagination={preorderList.pagination || undefined}
          onClickInfo={linkToPreorderDetail}
          onChangePage={setPreorderPage}
        />}
      {fullInfo && 
        <FiltersBar defaultFilters={initInfoClientPrepaymentDefaultFilters}>
          <FilterFromDate name="from" label={t("fromDate", { ns: 'order' })} />
          <FilterToDate name="to" label={t("toDate", { ns: 'order' })} />
          <FilterStatusOrder label={t("status", { ns: 'order' })} />
          <FilterNumber name="orderNumber" label={t("number", { ns: 'order' })} />
        </FiltersBar>}      
        <Orders
          rows={(orderList.orders || []).map(s => ({ data: s }))}
          loading={orderList.isFetching}
          pagination={orderList.pagination || undefined}
          fullInfo={fullInfo}
          adminInfo={true}
          onClickInfo={linkToOrderDetail}
          onChangePage={setOrderPage}
          isChaco={session.isChaco || (orderList && !orderList.isFetching && orderList.isChacoClient) || false}
          showDateStatus={false} // !isClient(session)}
        />
      {fullInfo && (!isStaff(session) || (isStaff(session) && !isLogistic)) && prepaymentCount > 0 &&
        <FiltersBar defaultFilters={initInfoClientPrepaymentDefaultFilters}>
          <FilterFromDate name="from" label={t("fromDate", { ns: 'prepayment' })} />
          <FilterToDate name="to" label={t("toDate", { ns: 'prepayment' })} />
          <FilterTel name="prepaymentNumber" label={t("number", { ns: 'prepayment' })} />
          <FilterText name="description" label={t("denomination", { ns: 'prepayment' })} controlledLength={3} />
          <FilterStatusPrepayment name="statusPP" label={t("status", { ns: 'prepayment' })} />
        </FiltersBar>}
      {prepaymentCount > 0 && (!isStaff(session) || (isStaff(session) && !isLogistic)) && <Prepayments
        rows={constructPrepaymentRows()}
        loading={prepaymentList.isFetching}
        fullInfo={fullInfo}
        adminInfo={true}
        pagination={prepaymentList.pagination || undefined}
        onClickDetail={linkToPrepaymentDetail}
        onChangePage={setPrepaymentPage}
      />}

      {fullInfo && (!isStaff(session) || (isStaff(session) && !isLogistic && !isAccounts)) && <FiltersBar defaultFilters={initInfoClientDefaultFilters}>
        <FilterNumber style={{ width: "110px" }} name="id" label={t("id", { ns: 'complaint' })} />
        <FilterFromDate name="dateOpenFrom" label={t("dateOpenFrom", { ns: 'complaint' })} />
        <FilterToDate name="dateOpenTo" label={t("dateOpenTo", { ns: 'complaint' })} />
        {!isClient(session) ? <FilterFromDate name="dateCloseFrom" label={t("dateCloseFrom", { ns: 'complaint' })} /> : <></>}
        {!isClient(session) ? <FilterToDate name="dateCloseTo" label={t("dateCloseTo", { ns: 'complaint' })} /> : <></>}
        <FilterStatusComplaint name="statusCP" label={t("status", { ns: 'complaint' })} />
        {!isClient(session) ? <FilterAssignedToComplaint name="assignedToId" label={t("assignedToName", { ns: 'complaint' })} /> : <></>}
      </FiltersBar>}
      {(!isStaff(session) || (isStaff(session) && !isLogistic && !isAccounts)) &&
        <Complaints
          rows={(complaintList.complaints || []).map(s => ({ data: s }))}
          loading={complaintList.isFetching}
          ownerId={session.personId || undefined}
          pagination={complaintList.pagination || undefined}
          onClickTracking={linkToComplaintTracking}
          adminInfo={false}
          clientInfo={true}
          isClient={isClient(session)}
          onChangePage={setComplaintPage}
          fullInfo={fullInfo}
        />}
      {(!isStaff(session) || (isStaff(session) && !isLogistic)) &&
        <TableDiscountList
          rows={(discountList.discountList || []).map(s => ({ data: s }))}
          loading={discountList.isFetching}
          fullInfo={fullInfo}
          adminInfo={true}
          codigo_cliente={params.codigo_cliente}
        />}

      <Box display="flex" justifyContent="flex-end" alignItems="center">
        <Button sx={{ textTransform: "none", margin: "10px" }} startIcon={<KeyboardReturnOutlined />} onClick={linkToBack}>{t("back", { ns: 'others' })}</Button>
      </Box>
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  invoiceList: state.invoiceList,
  bouncedReceiptList: state.bouncedReceiptList,
  orderList: state.orderList,
  currentAccountList: state.currentAccountList,
  clientDetail: state.clientDetail,
  personList: state.personList,
  prepaymentList: state.prepaymentList,
  preorder: state.preorderData,
  preorderList: state.preorderList,
  preorderCtrlList: state.preorderCtrlList,
  complaintList: state.complaintList,
  discountList: state.discountList,
  deliveryLocationList: state.deliveryLocationList,
  provinceList: state.provinceList,
  generalDescList: state.generalDescList,
  session: state.session
})

export default connect(mapStateToProps, null)(InfoClientList)

